/**
 * Règles d'accès par rôle, partagées par le menu (Menu.js) et les routes
 * (PermissionRoute). Un élément peut porter :
 *   roles       : le compte doit avoir AU MOINS UN de ces rôles ;
 *   rolesExcept : le compte doit avoir au moins un rôle HORS de cette liste
 *                 (ex. ["STUDENT","TEACHER"] = personnel d'administration) ;
 *   denyRoles   : refusé si le compte porte l'un de ces rôles.
 * Même le SUPER_ADMIN y est soumis : il ne voit pas les tableaux de bord
 * enseignant / étudiant, qui n'ont de sens que pour ces rôles.
 */
export function hasRoleAccess({ roles, rolesExcept, denyRoles } = {}, userRoles = []) {
  if (denyRoles && denyRoles.some((r) => userRoles.includes(r))) return false;
  if (roles && !roles.some((r) => userRoles.includes(r))) return false;
  if (rolesExcept && !userRoles.some((r) => !rolesExcept.includes(r))) return false;
  return true;
}

export const ADMIN_DASHBOARD_RULE = { rolesExcept: ["STUDENT", "TEACHER"] };

/** Page d'accueil selon le rôle. */
export function homePathForRoles(userRoles = []) {
  if (hasRoleAccess(ADMIN_DASHBOARD_RULE, userRoles)) return "/dashboard";
  if (userRoles.includes("TEACHER")) return "/teacher-dashboard";
  if (userRoles.includes("STUDENT")) return "/student-dashboard";
  return "/dashboard";
}

// Rôles « larges » : un compte qui en porte un n'est jamais limité à ses
// propres matières, même s'il est aussi enseignant (voir backend/utils/teacherScope.js).
const BROAD_ROLES = ["SUPER_ADMIN", "ADMIN", "FACULTY_ADMIN", "DEPARTMENT_HEAD", "SCOLARITY", "EXAM_MANAGER", "STUDIES_DIRECTOR", "EXAM_COMMITTEE"];

// Relevés de notes : l'accès est désormais piloté par les permissions TRANSCRIPT_*
// (voir canReadTranscripts / canExportTranscripts dans utils/permissions.js).

/** Enseignant « pur » : voit uniquement ses étudiants et ses matières. */
export function isTeacherOnly(userRoles = []) {
  return userRoles.includes("TEACHER") && !userRoles.some((r) => BROAD_ROLES.includes(r));
}